
import ApiService from "@/core/services/api.service";


export const SET_LISTA_PDVS_SALDO_TRANSACOES = "setListSaldoTransacoes";
export const SET_LISTA_PDVS_SALDO_TRANSACOES_REV = "setListSaldoTransacoesRev";
export const SET_PDVS_SALDO_TRANSACOES = "setSaldoTransacoes";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'




const actions = {
    //evento
    async create_saldo_transacoes(context, value) {

        await ApiService.post('saldo_transacoes', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },



    async create_saldo_transacoes_site(context, value) {

        let message = await ApiService.post('saldo_transacoes/produtor', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_PDVS_SALDO_TRANSACOES, message.message.conteudo)
    },

    async update_saldo_transacoes(context, value) {

        await ApiService.put('saldo_transacoes/'+value.id,value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_saldo_transacoess(context) {
        await ApiService.get('saldo_transacoes')
            .then(response => {
                context.commit(SET_LISTA_PDVS_SALDO_TRANSACOES, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },
    async listar_saldo_transacoes(context,value) {
        await ApiService.get('saldo_transacoes/ingressos/'+value)
            .then(response => {
                context.commit(SET_PDVS_SALDO_TRANSACOES, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },


    async delete_saldo_transacoes(context, value) {


        await ApiService.delete("saldo_transacoes/" + value.id)
          .then((response) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "success",
              message: response.data,
            })
          )
          .catch((error) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "error",
              message: error.response.data,
            })
          );
    
    
   
        context.commit(SET_LISTA_PDVS_SALDO_TRANSACOES_REV, value)
    
    
      },

      set_rota(context, value) {
        context.commit(SET_ROTA,value)
      }



};
const getters = {};

const mutations = {
    [SET_LISTA_PDVS_SALDO_TRANSACOES](state, value) {
        state.lista_saldo_transacoess = value;
    },
    [SET_LISTA_PDVS_SALDO_TRANSACOES_REV](state, value) {
        state.lista_saldo_transacoess = state.lista_saldo_transacoess.filter(
            (eventos) => eventos.id !== value.id
        );
    },
    [SET_PDVS_SALDO_TRANSACOES](state, value) {
        state.saldo_transacoes = value;
    },
    [SET_ROTA](state,value){
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
        let customMessage;
        if (typeof value.message === "object") {
    
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.msg,
        };
      },

};

const state = {
    lista_saldo_transacoess: [],
    lista_saldo_transacoess_Evento: [],
    saldo_transacoes:{},
    mensagem_alert: "",
    rota:"",

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
